module.exports = __webpack_public_path__ + "static/img/10.1a4306c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcco/10.png
// module id = yXAx
// module chunks = 0